import { WXOPENAPIS, MKWXOPENNEWAPIS } from '@api'
import LocalUser from './localUser'

// 小程序审核状态查询
export const miniAuthStatusCheck = () => {
  return new Promise(async resolve => {
    let miniUsable = true

    // 是否审核通过：0:审核成功 1:审核被拒绝  2:审核中  3:已撤回
    const { success, data: { status } } = await WXOPENAPIS.ThirdPlatformMiniAuthApi.miniAuthIsApprovedGet({ companyId: LocalUser.getUser().account })

    if (success) {
      resolve(status)
    } else {
      miniUsable = false
      resolve({ miniUsable })
    }
  })
}

// 微信小程序信息(包括审核信息等)
export const v2AuthMiniInformationGet = () => {
  return new Promise(async resolve => {
    const res = await MKWXOPENNEWAPIS.WxAuthApi.v2AuthMiniInformationGet({
      companyId: LocalUser.getUser().account
    })
    if (res && res.success && res.data.isAuth) {
      resolve({ isAuth: true })
    } else {
      resolve({ isAuth: false })
    }
  })
}

export default {
  v2AuthMiniInformationGet,
  miniAuthStatusCheck
}
